import secrets from '../../secrets';

export const rest = ({ path, url, credentials, ...options })  => {
  options = options || {};

  if (path && !url) {
    url = `${secrets.api.baseUri}/${path}`;
  }

  url = new URL(url);

  if (options.params) {
    const params = { ...options.params };

    Object.keys(params).forEach(key => {
      if (undefined === params[key] || null === params[key]) {
        delete params[key];
      }
    });

    url.search = new URLSearchParams(params).toString();
  }

  if (!options.method) { options.method = 'get' };

  options.headers = {
    'Content-Type': 'application/json',
    Accept: '*/*',
    'access-token': credentials.accessToken,
    ...credentials,
    ...options.headers
  }

  return fetch(url, options);
};
